import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { Job } from '../models/job.model';
import { JobStatusTypes } from '../models/enum/job-status-types.enum';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class BoardJobResolver implements Resolve<Observable<Job>> {
	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService
			.getProposalJobDetails(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					this.router.navigate(['/404']);
					return NEVER;
				}),
				tap(result => {
					GlobalSettingsService.isJobCompletedStatusVisible = result.statusId === JobStatusTypes.Completed;
				})
			);
	}
}
